import React from "react";
import Toggle from "react-toggle";
import "utils/toggle-css.css";
import "react-toggle/style.css";

const CustomToggle = (props) => <Toggle {...props} className="custom-toggle" />;

export default CustomToggle;
